import { render } from "./ReturnAndRefundShowComponent.vue?vue&type=template&id=f540d3fe"
import script from "./ReturnAndRefundShowComponent.vue?vue&type=script&lang=js"
export * from "./ReturnAndRefundShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/returnAndRefunds/ReturnAndRefundShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f540d3fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f540d3fe', __exports__)) {
    api.reload('f540d3fe', __exports__)
  }
  
  module.hot.accept("./ReturnAndRefundShowComponent.vue?vue&type=template&id=f540d3fe", () => {
    api.rerender('f540d3fe', render)
  })

}


export default __exports__